import { render, staticRenderFns } from "./ConfigWebsiteCohortsCreate.vue?vue&type=template&id=22478f74&scoped=true"
import script from "./ConfigWebsiteCohortsCreate.vue?vue&type=script&lang=js"
export * from "./ConfigWebsiteCohortsCreate.vue?vue&type=script&lang=js"
import style0 from "./ConfigWebsiteCohortsCreate.vue?vue&type=style&index=0&id=22478f74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22478f74",
  null
  
)

export default component.exports